import React, {useContext, useEffect, useState} from 'react'
import Account from './Account'
import Data from './Data'
import History from './History'
import Payments from './Payments'
import ChangeAccountBalance from './ChangeAccountBalance'
import { LawyerContext, UserContext, LoadingContext } from '../../../partials/Context'
import {Errors} from '../../../partials/Partials'

function Portfel() {
    const [services, setServices] = useState([]);
    const lawyer = useContext(LawyerContext);
    const user = useContext(UserContext);
    const [lawyer_data, setLawyerData] = useState({});
    const {id} = lawyer || ''
    const [current_balance, setCurrentBalance] = useState(null);
    const [payment_data, setPaymentData] = useState({});
    const {setLoading} = useContext(LoadingContext)
    const [errors, setErrors] = useState([])
    const {has_recurring_payment_on} = lawyer_data || ''
    const [payment_turned_off, setPaymentTurnedOff] = useState(false)

    const {is_staff} = user || '';

    const pathname = window.location.pathname
    let url_id = ''

    if (is_staff) {
      if (pathname.slice(1,-1).split('/').length > 1) {
        url_id = pathname.slice(1,-1).split('/')[1]
        if (url_id.split('-').length > 1) {
          url_id = url_id.split('-')[1]
        }
      }
    }

    const {photo_url} = lawyer || '';
    const current_id = is_staff && url_id !== '' ? url_id : id

    const getLawyerData = () => {
      fetch(`/api/lawyer_profiles_extended/${current_id}`).then(res => {
      if (res.ok) {
        res.json().then(
          data => {
              setLawyerData(data)
              setCurrentBalance(data.balance)
              setLoading(false)
          }
        )
      } else {
        setErrors(['Nie udało się pobrać danych'])
        setLoading(false)
      }
    })
    }


    useEffect(() => {
    if (id) {
      setLoading(true)
      getLawyerData()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[id, current_balance])

    useEffect(() => {
      setLoading(true)
        fetch('/api/przelewy24/lawyer-services').then(res => {
          if (res.ok) {
            res.json().then(data => {
            setServices(data.available_services)
            setLoading(false)
            })
          } else {
            setErrors(['Nie udało się pobrać danych'])
            setLoading(false)
          }
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
    
  return (
    <>
    {payment_turned_off ? 
      <div className="alert alert-success">Płatność cykliczna została wyłączona</div>
      : null
    }
    <div className="prawnik-portfel">
        
        <div className="photo-column">
            <img src={photo_url} alt="zdjęcie profilowe prawnika" />
        </div>
        <div className="portfel-content">
          <Errors errors={errors}/>
            {is_staff ? 
                <ChangeAccountBalance setCurrentBalance={setCurrentBalance} services={services} lawyer_data={lawyer_data}/>
            : null}
            <Data lawyer_data={lawyer_data} lawyer={lawyer} setPaymentData={setPaymentData} payment_data={payment_data}/>
            <Payments services={services} payment_data={payment_data} id={id} has_recurring_payment_on={has_recurring_payment_on} getLawyerData={getLawyerData} setPaymentTurnedOff={setPaymentTurnedOff}/>
            <Account lawyer_data={lawyer_data}/>
            <History id={current_id} current_balance={current_balance}/>
        </div>
    </div>
    </>
  )
}

export default Portfel